import { toast } from "react-toastify";
// import { FaCheckCircle } from "react-icons/fa";
import React from "react";

export const showQuantityToast = (productTitle, quantity) => {
  toast(
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span style={{ fontSize: "20px" }}>🛒</span>

      <div>
        <div style={{ fontWeight: 600, color: "#111827" }}>Cart Updated</div>

        <div style={{ fontSize: "13px", color: "#6B7280" }}>
          <strong>{productTitle}</strong> quantity changed to{" "}
          <strong>{quantity}</strong>.
        </div>
      </div>
    </div>,
    {
      autoClose: 1000,
      hideProgressBar: true,
      closeButton: false,
      icon: false,
      style: {
        background: "#fff",
        color: "#111827",
        borderRadius: "12px",
        padding: "14px 16px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        minWidth: "320px",
      },
    },
  );
};
